import { Headset, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ChatIconProps {
  onClick: () => void;
  isOpen: boolean;
  controlsId?: string;
  className?: string;
}

export const ChatIcon = ({
  onClick,
  isOpen,
  controlsId = "customer-support-chat",
  className,
}: ChatIconProps) => (
  <Button
    id={`${controlsId}-trigger`}
    type="button"
    onClick={onClick}
    aria-label={isOpen ? "Close Mbaay Customer Care" : "Open Mbaay Customer Care"}
    aria-expanded={isOpen}
    aria-controls={isOpen ? controlsId : undefined}
    aria-haspopup="dialog"
    className={cn(
      "fixed bottom-5 right-6 z-50 h-14 w-14 rounded-full p-0",
      "bg-orange-500 text-white shadow-lg hover:bg-orange-600",
      "hover:scale-110 active:scale-95",
      "transition-all duration-300 ease-out motion-reduce:transition-none",
      "hover:shadow-xl",
      isOpen && "rotate-180",
      isOpen && "[@media(max-height:500px)]:hidden",
      className,
    )}
    size="icon"
  >
    {isOpen ? (
      <X className="h-6 w-6" aria-hidden="true" />
    ) : (
      <Headset className="h-6 w-6" aria-hidden="true" />
    )}
  </Button>
);
